






























import { Component, Vue, Prop } from 'vue-property-decorator';
import AccountIcon from '@/components/common/AccountIcon.vue';
import { GitHistory, Worker, Operation } from '@/@types/LibraryComponent';

@Component({
  components: {
    AccountIcon,
  },
})
export default class GitHistoryCard extends Vue {
  @Prop()
  private history!: GitHistory;
  private author: Worker = this.history.author;
  private operation: Operation = this.history.operation;
  private type: string = this.history.operation.name;
}
